import {RestAPI} from '@/constants/routeAPI';
import apiRequestTracker from '@/observers/apiRequestTracker';

import axiosMethods from './apiManager';

// eslint-disable-next-line import/prefer-default-export
export const getRowValueVolSensor = async () => {
  const response = await axiosMethods.get(RestAPI.ROW_VALUE_VOLUME_SENSOR, null, true, true);
  return response;
};

export const cancelRowValueVolSensor = async () => {
  apiRequestTracker.cancelRequest([RestAPI.ROW_VALUE_VOLUME_SENSOR]);
};
